<template>
  <div class="modal fade" id="modalEducacionCreate" tabindex="-1" role="dialog" aria-labelledby="modalEducacionCreateLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold text-primary" id="modalEducacionCreateLabel">
            <i class="fas fa-book-open mr-2"></i> Registrar Educación Médica
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="guardar">
            <div class="form-row mb-3">
              <div class="form-group col-md-6">
                <label class="font-weight-bold small">Fecha <span class="text-danger">*</span></label>
                <input type="date" v-model="form.fecha" class="form-control form-control-sm" required />
              </div>
              <div class="form-group col-md-6">
                <label class="font-weight-bold small">Tema / Educación <span class="text-danger">*</span></label>
                <select disabled v-model="form.id_educacion" class="form-control form-control-sm" required>
                  <option v-for="item in listaEducaciones" :key="item.id" :value="item.id">
                    {{ item.nombre }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="font-weight-bold small">Detalle / Texto <span class="text-danger">*</span></label>
              <textarea
                v-model="form.texto"
                rows="5"
                class="form-control"
                placeholder="Escriba el detalle de la educación brindada al paciente..."
                required
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">
            <i class="far fa-times-circle mr-1"></i> Cancelar
          </button>
          <button type="button" class="btn btn-primary btn-sm" :disabled="cargando" @click="guardar">
            <i class="fas fa-save mr-1" v-if="!cargando"></i>
            <i class="fas fa-spinner fa-spin mr-1" v-else></i> Guardar Educación
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import dayjs from "dayjs";
import educacionService from "@/services/educacionService";
import historiaEducacionService from "@/services/historiaEducacionService";
import Toast from "@/components/common/utilities/toast";

export default {
  name: "ModalEducacionCreate",
  props: ['idUsuario', 'usuario', 'edad'],
  data() {
    return {
      cargando: false,
      listaEducaciones: [],
      form: {
        fecha: dayjs().format("YYYY-MM-DD"),
        id_educacion: "",
        texto: ""
      },
      grupos: [
        { code: 'INF', start: 0, end: 5 },
        { code: 'PRIM_INF', start: 6, end: 11 },
        { code: 'AD', start: 12, end: 17 },
        { code: 'JUV', start: 18, end: 29 },
        { code: 'ADU', start: 30, end: 59 },
        { code: 'VEJ', start: 60, end: null }
      ]
    };
  },
  methods: {
    async open() {
      this.form.fecha = dayjs().format("YYYY-MM-DD");
      this.form.id_educacion = "";
      this.form.texto = "";
      await this.cargarEducaciones();
      $("#modalEducacionCreate").modal("show");
    },
    async cargarEducaciones() {
      try {
        let codigo = "";
        if (this.edad !== undefined && this.edad !== null && this.edad !== "") {
          const grupo = this.grupos.find(g => {
            if (g.end === null) {
              return Number(this.edad) >= g.start;
            }
            return Number(this.edad) >= g.start && Number(this.edad) <= g.end;
          });
          if (grupo) {
            codigo = grupo.code;
          }
        }

        if (!codigo) return;

        const res = await educacionService.showByCodigo(codigo);
        const list = Array.isArray(res.data) ? res.data : (res.data ? [res.data] : []);
        this.listaEducaciones = list;
        if (list.length > 0) {
          this.form.id_educacion = list[0].id;
          if (list[0].default_text && !this.form.texto) {
            this.form.texto = list[0].default_text;
          }
        }
      } catch (e) {
        console.error("Error al cargar educaciones:", e);
      }
    },
    async guardar() {
      if (!this.form.fecha || !this.form.id_educacion || !this.form.texto) {
        Toast.fire({
          icon: "warning",
          title: "Complete todos los campos requeridos"
        });
        return;
      }

      this.cargando = true;
      try {
        const payload = {
          id_usuario: this.idUsuario,
          id_educacion: this.form.id_educacion,
          fecha: dayjs(this.form.fecha).format("YYYY-MM-DD"),
          texto: this.form.texto
        };

        const res = await historiaEducacionService.storeUser(payload);
        if (res.data && res.data.status === "ok") {
          Toast.fire({
            icon: "success",
            title: "Educación guardada con éxito"
          });
          $("#modalEducacionCreate").modal("hide");
          this.$emit("educacion-guardada");
        } else {
          Toast.fire({
            icon: "error",
            title: "No se pudo guardar la educación"
          });
        }
      } catch (e) {
        console.error("Error al guardar educación:", e);
        Toast.fire({
          icon: "error",
          title: "Ocurrió un error al procesar la solicitud"
        });
      } finally {
        this.cargando = false;
      }
    }
  }
};
</script>
